import { appConfig } from '../app.config';
import { callErrorNotification } from '@components/Notification';
import { APP_TEXTS } from '@texts';

const BASE_URL = appConfig.BASE_URL + appConfig.API_PATH;

class HttpService {

  get(params) {
    return this.http({ method: 'GET', ...params});
  }

  patch(params) {
    return this.http({ method: 'patch', ...params});
  }

  post(params) {
    return this.http({ method: 'POST', ...params});
  }

  remove(params) {
    return this.http({ method: 'delete', ...params});
  }


  http({ method, query, data }) {
    if (!query) throw new TypeError('Query is required!');

    const body = data ? JSON.stringify(data) : null;

    const headers = Object.values(appConfig.nonAuthPath).includes(query)
      ? this.getDefaultHeaders(body)
      : this.getHeaders(body);

    return fetch(BASE_URL + query, {
      method,
      body,
      headers
    })
      .then(res => {
        if(!res.ok)
          // throw(new Error(res));
          return Promise.reject(res);
        return res;
      })
      .then(res => res.json(), res => this.handleServerError(res.json()))
      .then(res => res.d)
      .catch(err => this.handleFetchError(err));
  }


  getHeaders(body) {
    let ClientId = "";

    try {
      ClientId = JSON.parse(window.sessionStorage.getItem('clientId') || "");
    } catch (e) {
      console.error(JSON.stringify(e, null, 3));
    }

    return {...this.getDefaultHeaders(body), ...{ ClientId }};
  }

  getDefaultHeaders(body) {
    return {
      'Content-Type': 'application/json',
      'Content-Length': body ? body.length : 0
    };
  }


  handleServerError = (err) => {
    console.error(err);
    err.then((errRes) => {
      // callErrorNotification('Something went wrong with server:\n' + errRes.Message);
      callErrorNotification(errRes.Message);
    });

    return err;
  };

  handleFetchError = (err) => {
    console.error(err);
    callErrorNotification(APP_TEXTS.NOTIFICATION_ERROR_REQUEST.Content+'\n' + err.message);

    return err;
  };

}

export default new HttpService();



// WEBPACK FOOTER //
// ./src/services/http.service.js